import * as React from 'react';
import { Draggable } from '@hello-pangea/dnd';
import { Trash2Icon, GripVerticalIcon } from 'lucide-react'
import type { TripStopLocation } from 'contracts/transport-routes';
import { useTranslation } from 'hooks';
import { TableRow, TableCell } from 'components/ui/table';
import { cn } from 'lib/utils';

import { translations } from './translations';
import { generateLocationName } from './utils';

type Props = {
  index: number;
  location: TripStopLocation;
  onClickRemoveStopLocation: (location: TripStopLocation) => void;
}

export const TripStopListItem = ({ index, location, onClickRemoveStopLocation }: Props) => {
  const { getTranslation: t } = useTranslation(translations);

  const locationType = React.useMemo(() => {
    return location.type === 'city'
      ? t('cityType')
      : t('coordinatesType');
  }, [t, location.type]);

  return (
    <Draggable draggableId={`${location.id}`} index={index}>
      {(provided, snapshot) => (
        <TableRow
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          ref={provided.innerRef}
          style={provided.draggableProps.style as React.CSSProperties | undefined}
          role="button"
          onClick={() => console.log('maybe open modal to edit the location', location)}
          className={cn(
            'z-10 truncate bg-card shadow-none transition-colors hover:shadow-md',
            snapshot.isDragging && 'shadow-md',
          )}
        >
          <TableCell><GripVerticalIcon className={'text-gray-500'} /></TableCell>
          <TableCell>{locationType}</TableCell>
          <TableCell>{generateLocationName(location)}</TableCell>
          <TableCell className={'w-full flex flex-row items-center'}>
            <button className={'ml-auto'} onClick={() => onClickRemoveStopLocation(location)}>
              <Trash2Icon className={'text-red-500'} />
            </button>
          </TableCell>
        </TableRow>
      )}
    </Draggable>
  );
};